// src/components/ReferralHandler.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component to handle referral code capture from URL paths
 * When a user visits ecombuddha.ai/sambhav2025, this component:
 * 1. Extracts "sambhav2025" as the referral code
 * 2. Validates it against the whitelist
 * 3. Stores it in localStorage if valid
 * 4. Redirects to the home page
 */

// Whitelist of valid referral codes - must match backend
const VALID_REFERRAL_CODES = [
  'sambhav2025',
  // Add more valid codes here as needed
  // 'promo2025',
  // 'launch2025',
];

const ReferralHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Get the path without leading slash
    const path = location.pathname.substring(1);

    // List of known routes that should NOT be treated as referral codes
    const knownRoutes = [
      'home',
      'blog',
      'solutions',
      'pricing',
      'auth',
      'about',
      'contact',
      'dashboard',
      ''
    ];

    // Check if the path is NOT a known route (and not empty)
    if (path && !knownRoutes.includes(path) && !path.startsWith('dashboard/')) {
      // Check if this is a valid referral code
      if (VALID_REFERRAL_CODES.includes(path)) {
        // Valid referral code found
        // Store the referral code in localStorage
        localStorage.setItem('referralCode', path);
        localStorage.setItem('referralCodeTimestamp', Date.now().toString());
      }

      // Redirect to home page regardless
      navigate('/auth', { replace: true });
    } else {
      // Not a referral code, redirect to home
      navigate('/auth', { replace: true });
    }
  }, [location, navigate]);

  // This component doesn't render anything
  return null;
};

export default ReferralHandler;
